var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "customer-benefits" }, [
    _c(
      "div",
      { staticClass: "customer-benefits--items" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { md: "4" } }, [
              _c(
                "div",
                { staticClass: "customer-benefits--items-column" },
                [
                  _c("Item", {
                    attrs: {
                      title: "Unlimitierte Jobs",
                      text:
                        "Egal, wie viele Jobprofile du anlegst. Du zahlst erst, wenn du Kontaktanfragen annimmst oder sendest.",
                      color: "purple"
                    }
                  }),
                  _vm._v(" "),
                  _c("Item", {
                    attrs: {
                      title: "Kontaktsystem & Bewerbermanagement",
                      text:
                        "Du nimmst direkt Kontakt mit ausgewählten Bewerbern auf, vereinbarst einfach Gesprächstermine, startest Vertragsverhandlungen und sendest Zu- bzw. Absagen. Entwickelt aus jahrzehntelanger, täglicher Erfahrung von Personalisten.",
                      color: "orange"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { md: "4" } }, [
              _c(
                "div",
                { staticClass: "customer-benefits--items-column" },
                [
                  _c("Item", {
                    attrs: {
                      title: "Unlimitierte Filter",
                      text:
                        "Setze kostenlos so viele Filter, wie du willst.<br/>Achtung: Zu viele Filter können die Suchergebnisse des Best-Match-Systems auch zu stark einschränken!",
                      color: "turquoise"
                    }
                  }),
                  _vm._v(" "),
                  _c("Item", {
                    attrs: {
                      title: "Ein Guthaben für alle Jobs.",
                      text:
                        "Egal wie viele Job-Profile du anlegst: erst wenn du Personen kontaktieren willst, kaufst Du ein Guthaben und kannst es für verschiedene Jobs verwenden. Du brauchst also kein Einzelguthaben je Job-Profil. Das ist kostengünstiger und du behältst die Übersicht.<br/><b>skilldoo bietet absolute Kostentransparenz.</b>",
                      color: "olive"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { md: "4" } }, [
              _c(
                "div",
                { staticClass: "customer-benefits--items-column" },
                [
                  _c("Item", {
                    attrs: {
                      title: "Anonym",
                      text:
                        "Du kannst Stellen anonym ausschreiben. Denn eventuell ist die ausgeschriebene Position noch besetzt.",
                      color: "gold"
                    }
                  }),
                  _vm._v(" "),
                  _c("Item", {
                    attrs: {
                      title: "Passend, einfach und schnell",
                      text:
                        "Durch das Best-Match-System werden nur passende BewerberInnen angezeigt. Damit sparst du Zeit und Geld.",
                      color: "lime"
                    }
                  })
                ],
                1
              )
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }